// 凡例（M-159 分析サマリー primitive）。色スウォッチ 12px 角丸 3px + ラベル。
import { cn } from '@kawai/ui';

export type ChartLegendItem = {
  key: string;
  label: string;
  /** bg-viz-* 等のトークン由来クラス */
  className: string;
  /** 任意で人数等を併記 */
  value?: string | number;
};

export type ChartLegendProps = {
  items: readonly ChartLegendItem[];
  className?: string;
  'aria-label'?: string;
};

export function ChartLegend({
  items,
  className,
  'aria-label': ariaLabel,
}: ChartLegendProps) {
  return (
    <ul
      className={cn('flex flex-wrap gap-x-4 gap-y-1 text-note text-ink-2', className)}
      aria-label={ariaLabel}
      data-testid="chart-legend"
    >
      {items.map((item) => (
        <li key={item.key} className="flex items-center gap-1.5">
          <span
            className={cn('inline-block h-3 w-3 shrink-0 rounded-[3px]', item.className)}
            aria-hidden="true"
            data-testid={`legend-swatch-${item.key}`}
          />
          <span>{item.label}</span>
          {item.value !== undefined ? (
            <span className="ui-num tabular-nums text-ink">{item.value}</span>
          ) : null}
        </li>
      ))}
    </ul>
  );
}
